export default {"src":"/_next/static/media/ticketz.4b7aa9c0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};